<template>
  <div class="content">
    <h3>Experiment step 1/2:</h3>
    <strong>Add Gaussian noise to each object and background in an image.</strong>
    <b-card>
        <b-row>
            <b-col>
                Original Image:
                <b-img v-bind:src="experiment1" style="min-width:230px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
                Add Noise on Flower:
                <b-img v-bind:src="experiment2" style="min-width:240px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
                Add Noise on Cactus:
                <b-img v-bind:src="experiment3" style="min-width:240px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
            <b-col>
                Add Noise on Background:
                <b-img v-bind:src="experiment4" style="min-width:240px;max-width:100%;" alt="placeholder"></b-img>
            </b-col>
        </b-row>
    </b-card>

    <br>
    <h3>Experiment step 2/2:</h3>
    <strong>Ask AMT (Amazon Mechanical Turk) workers to distinguish the tampered Image from the original image.</strong>
    
    <br>
    If you are interested, please try our <a href="https://ncript.comp.nus.edu.sg/site/experiment/index.php/Home/Work/startsession?taskid=2037">live demo</a>.
    <br>
    Note: In case you cannot pass the robot validation page, please return to this page and try again :-)

    <br><br>
    <b-card>
    <strong>The experiment interface is shown below:</strong>
    <b-img v-bind:src="experiment" style="min-width:400px;width:1000px;max-width:100%;" alt="placeholder"></b-img>
    </b-card>
    
  </div>
</template>

<script>

export default {
  name: 'Experiment',
  data(){
      return {
        experiment1: require('../assets/experiment/0068.jpg'),
        experiment2: require('../assets/experiment/0068_0.jpg'),
        experiment3: require('../assets/experiment/0068_1.jpg'),
        experiment4: require('../assets/experiment/0068_2.jpg'),

        experiment: require('../assets/experiment/experiment.png'),
      }
  },
  components:{
  }
}
</script>

<style scoped>

</style>
